import type { CategoryContent } from './row.js';

/** Dutch & International IP Law. */

export const LAWIP: CategoryContent = {
  bscba: [
    [
      'Under most copyright systems worldwide, is copyright registration required for a work to gain copyright protection?',
      [
        'No, copyright arises automatically upon creation in virtually all countries that are signatories to major international copyright treaties',
        'Yes, every country requires registration with a national copyright office before protection begins',
        'Only in the United States and Japan',
        'Only if the work is published in printed form',
      ],
      0,
      'The Berne Convention established that copyright is automatic—no registration, notice, or other formality is required. Most countries today follow this principle, though some maintain optional national registries for evidentiary purposes.',
    ],
    [
      'What is a trademark\'s primary legal purpose?',
      [
        'To identify the source or origin of goods or services and distinguish them from others',
        'To prevent any other company from using similar words or symbols',
        'To extend the copyright protection of a brand name indefinitely',
        'To grant exclusive rights to use a particular word in any context whatsoever',
      ],
      0,
      'A trademark\'s core function is to serve as a badge of origin, helping consumers recognise goods or services from a particular source. This origin-indicating function is what most trademark laws protect.',
    ],
    [
      'Which of the following is NOT typically considered patentable subject matter?',
      [
        'A naturally occurring gene sequence extracted from a human body without modification',
        'A novel chemical compound synthetically created in a laboratory',
        'A new manufacturing process for producing semiconductors',
        'A useful device combining existing components in an innovative way',
      ],
      0,
      'Natural products, laws of nature, and abstract ideas are generally unpatentable in most jurisdictions. However, a genetically modified organism or a purified natural substance with new properties may be patentable.',
    ],
    [
      'What does "first-to-file" mean in patent law?',
      [
        'The person who files a patent application first has priority, regardless of who actually invented it',
        'Only the original inventor is entitled to file a patent application',
        'Patent rights belong to whoever publishes about the invention in a peer-reviewed journal first',
        'Inventors must publish their discovery before filing a patent to establish priority',
      ],
      0,
      'Most countries worldwide, including the EU and many others, use a first-to-file system where the earliest filing date determines priority. The US historically used first-to-invent until 2013.',
    ],
    [
      'How long does a standard patent grant protect an invention?',
      [
        '20 years from the filing date of the application',
        '17 years from the date the patent is granted',
        'Life of the inventor plus 50 years',
        'Indefinitely, as long as the patent holder pays annual renewal fees',
      ],
      0,
      'The standard patent term in most countries is 20 years from the filing date. However, the invention itself becomes public at filing, and the actual protection period can be reduced if the patent takes years to examine and grant.',
    ],
    [
      'What is a trade secret?',
      [
        'Information that derives value from not being generally known and is kept secret through reasonable efforts',
        'A patent that has not yet been published by the patent office',
        'A trademark that is confidential and not disclosed to the public',
        'A copy of a company\'s financial records locked in a safe',
      ],
      0,
      'Trade secrets protect information through secrecy and reasonable protective measures rather than through registration. They require no formal procedures but offer protection only so long as the information remains confidential.',
    ],
    [
      'Which international treaty established that copyright protection does not require registration or notice?',
      [
        'The Berne Convention for the Protection of Literary and Artistic Works',
        'The Paris Convention for the Protection of Industrial Property',
        'The TRIPS Agreement',
        'The World Intellectual Property Organization Founding Treaty',
      ],
      0,
      'The Berne Convention (1886) established in Article 5(2) that copyright protection is automatic and does not depend on any formality like registration, notice, or deposit. TRIPS and the WIPO treaties later incorporated this principle.',
    ],
    [
      'What is the Madrid Protocol primarily used for?',
      [
        'Filing trademark applications in multiple countries through a single WIPO procedure',
        'Harmonising copyright laws across European Union member states',
        'Enforcing patents across all countries simultaneously',
        'Registering geographical indications for agricultural products',
      ],
      0,
      'The Madrid Protocol, administered by WIPO, centralises trademark filing through one application covering multiple designated countries. However, each country\'s office still examines the mark under its own substantive law.',
    ],
    [
      'What is the basic requirement for copyright protection of a literary or artistic work?',
      [
        'The work must be original and be expressed in a tangible medium (written, recorded, etc.)',
        'The work must be commercially published',
        'The work must be registered with a national copyright office',
        'The work must be at least 100 pages long or one hour in duration',
      ],
      0,
      'Copyright protects original literary and artistic works once they are fixed in a tangible medium—such as writing, recording, or digital storage. Originality and fixation are the key requirements; publication or registration are not.',
    ],
    [
      'What does the European Patent Office (EPO) grant?',
      [
        'A bundle of national patents in designated countries, which must be validated and enforced separately in each',
        'A single European patent that is automatically valid and enforceable identically throughout the entire EU',
        'Only utility patents, while design patents are handled exclusively by WIPO',
        'A preliminary patent right that becomes a full patent only after European Union approval',
      ],
      0,
      'A European patent granted by the EPO under the European Patent Convention is really a bundle that must be validated in each designated country and can be separately enforced or revoked in each.',
    ],
    [
      'Which of the following best describes the Paris Convention\'s contribution to international patent and trademark law?',
      [
        'It established the "priority right" allowing applicants to file in multiple countries while retaining their first filing date',
        'It abolished patents in developing countries',
        'It created WIPO as its enforcement agency',
        'It unified patent examination procedures across all signatory nations',
      ],
      0,
      'The Paris Convention (1883) introduced the priority right: applicants can file in one member country and then file in other members within 12 months for patents or 6 months for trademarks while keeping the original filing date as priority.',
    ],
    [
      'What distinguishes a moral right from an economic right in copyright?',
      [
        'Moral rights protect the author\'s personal connection to a work (attribution, integrity) and are generally inalienable',
        'Moral rights last only one year while economic rights last for the copyright term',
        'Economic rights apply only to books; moral rights apply only to visual art',
        'Moral rights exist only in English-speaking countries',
      ],
      0,
      'Moral rights—the right of attribution and the right against distortion or mutilation—protect the author\'s reputation and personal bond with their work. Unlike economic rights, they typically cannot be sold or transferred, even in civil-law countries where authors assign their economic rights.',
    ],
    [
      'What does it mean if a trademark becomes "generic"?',
      [
        'The term has become the common name for the product in ordinary language, risking loss of trademark protection',
        'The trademark has been registered in multiple countries',
        'The trademark owner has allowed third parties to use the mark in advertising',
        'The trademark is no longer fashionable among consumers',
      ],
      0,
      'Genericide occurs when a trademark becomes the ordinary name for the product itself (like "aspirin" or "escalator" in the US). Trademark owners combat this by always pairing the mark with the product\'s generic name.',
    ],
    [
      'What is the primary role of the World Intellectual Property Organization (WIPO)?',
      [
        'To administer international IP treaties and provide services for patent, trademark, and design registration and dispute resolution',
        'To directly prosecute counterfeiters and conduct enforcement raids globally',
        'To set uniform IP laws that all countries must immediately adopt',
        'To grant patents and trademarks directly, replacing national patent and trademark offices',
      ],
      0,
      'WIPO, a UN specialised agency since 1974, administers treaties like the Paris Convention, Berne Convention, PCT, and Madrid Protocol. It provides services and dispute resolution but does not enforce IP rights—that remains a national court function.',
    ],
    [
      'How does copyright protection differ from patent protection in terms of scope?',
      [
        'Copyright protects literary and artistic expression, while patents protect inventions and technical solutions',
        'Patents protect ideas, while copyrights protect physical objects only',
        'Copyright is renewable indefinitely, while patents are granted only once',
        'Patents protect moral rights, while copyrights protect only economic rights',
      ],
      0,
      'Copyright protects the original expression of ideas in literary and artistic works (books, music, films, software). Patents protect inventions and technical solutions. They cover different subject matter and different legal mechanisms.',
    ],
  ],
  msc: [
    [
      'The Dutch Burgerlijk Wetboek is organised into how many books?',
      ['ten', 'six', 'four', 'eight'],
      0,
      'The BW runs Book 1 (persons and family) through Book 10 (private international law), with Books 7 and 7A covering specific contracts. It replaced the old 1838 code in stages from 1970 to 1992.',
    ],
    [
      'The Hoge Raad der Nederlanden is best described as what?',
      [
        'The supreme court for civil, criminal and tax cases, reviewing on points of law',
        'The constitutional court that strikes down unconstitutional statutes passed by the States-General',
        'The highest administrative court for disputes with the government',
        'The court that tries government ministers for office-related offences',
      ],
      0,
      'The Hoge Raad does not retry facts; it is a court of cassation, checking whether the law was applied correctly. The Netherlands has no constitutional review of Acts of Parliament by the judiciary - Article 120 of the Constitution forbids it.',
    ],
    [
      'A trademark becomes vulnerable to cancellation for "genericide" when what happens?',
      [
        'It becomes the common name for the product in ordinary language, through the owner\'s own inaction',
        'It is used by a licensee without a written licence agreement',
        'It is registered in a class that does not match its actual use',
        'It is not renewed within five years of the original filing date set out in the relevant national trademark register',
      ],
      0,
      '"Aspirin" and "escalator" both lost trademark protection in the US this way. Owners defend against it by policing generic use and always pairing the mark with the product\'s generic name, e.g. "Velcro brand fasteners."',
    ],
    [
      'Under the Berne Convention, a member country may not require what as a condition of copyright protection?',
      [
        'Any formality, such as registration or a copyright notice',
        'Publication within the country of origin',
        'Translation into the language of the country claiming protection',
        'Payment of a filing fee to a national copyright office',
      ],
      0,
      'Berne\'s "no formalities" rule (Article 5(2)) is why copyright is automatic on creation almost everywhere. The US only joined Berne in 1989 and had to abandon its mandatory notice requirement to comply.',
    ],
    [
      'The standard Berne Convention minimum term for copyright is what?',
      [
        'Life of the author plus 50 years',
        'Life of the author plus 70 years',
        '50 years from first publication, regardless of authorship',
        '25 years from creation',
      ],
      0,
      'Berne sets the floor at life-plus-50; the EU raised its own term to life-plus-70 in 1993, and the US matched that in 1998 with the Sonny Bono Act. Many countries still sit at the Berne minimum.',
    ],
    [
      'The European Patent Office grants what kind of right?',
      [
        'A bundle of national patents in the designated states, not a single EU-wide patent',
        'A single patent enforceable identically in every EU member state',
        'A patent valid only in Germany, France and the UK, with no possibility of extension to any other contracting state',
        'A provisional right that must be confirmed by each country\'s own patent office',
      ],
      0,
      'A "European patent" granted by the EPO under the European Patent Convention is really a bundle: it must be validated and can be separately revoked or licensed in each designated country. The Unitary Patent, which finally creates one single right, only started operating in 2023.',
    ],
    [
      'To be patentable in most systems, an invention must be novel, non-obvious (inventive) and what?',
      ['Susceptible of industrial application', 'Filed by a corporation', 'Kept secret for one year before filing', 'Reduced to a physical prototype'],
      0,
      'Novelty, inventive step and industrial applicability are the three EPC pillars (Article 52). "Reduction to practice" is a US-specific historical concept from the old first-to-invent system, not a general requirement.',
    ],
    [
      'The Dutch word "auteursrecht" translates most directly to what?',
      ['Author\'s right', 'Publishing licence', 'Trade secret', 'Registered design'],
      0,
      'Continental European systems, including the Dutch one, frame copyright as an "author\'s right" centred on the creator\'s personal and moral connection to the work, in contrast with the Anglo-American "copyright" tradition, which historically centred on the economic right to copy.',
    ],
    [
      'The Benelux trademark and design system is unusual because it does what?',
      [
        'Registers a single mark valid across Belgium, the Netherlands and Luxembourg as one territory',
        'Requires separate filings in each of the three countries',
        'Only covers trademarks, not designs, since design protection is handled exclusively by each country\'s national office',
        'Grants protection automatically without any registration',
      ],
      0,
      'The Benelux Office for Intellectual Property (BOIP) predates the EU trademark system and still runs a genuinely unified three-country registration, one of the oldest supranational IP regimes in the world.',
    ],
    [
      'WIPO, the World Intellectual Property Organization, operates as what?',
      [
        'A specialised agency of the United Nations administering IP treaties',
        'A branch of the World Trade Organization responsible specifically for enforcing trade-related sanctions',
        'An EU institution with authority only over member states',
        'A private industry association with no treaty-making role',
      ],
      0,
      'WIPO became a UN specialised agency in 1974 and administers treaties like the Paris Convention, Berne Convention, PCT and Madrid Protocol, though it has no independent enforcement power - that is left to national courts and, for trade-related disputes, the WTO.',
    ],
    [
      'The Paris Convention\'s "priority right" allows an applicant who files a patent or trademark in one member country to do what?',
      [
        'File in other member countries within a set period while keeping the original filing date',
        'Automatically receive protection in every other member country',
        'Extend the term of protection in the country of first filing by an additional period equal to the priority window itself',
        'Transfer the application to another applicant without a formal assignment',
      ],
      0,
      'The priority period is 12 months for patents and 6 months for trademarks and designs. It exists precisely because simultaneous worldwide filing was never realistic, so the Convention lets a later foreign filing be treated as if it happened on the first filing date.',
    ],
    [
      'The economic rights in a copyrighted work (e.g. reproduction, distribution) differ from moral rights chiefly because moral rights do what?',
      [
        'Protect the author\'s personal connection to the work (attribution, integrity) and are generally non-transferable',
        'Can be freely bought and sold like any other property',
        'Only exist in common-law jurisdictions, where they were first codified in early twentieth-century statutes governing artistic and literary works',
        'Expire immediately on the work\'s first publication',
      ],
      0,
      'Moral rights - the right of attribution and the right against distortion or mutilation of the work - are treated in most civil-law systems, including the Dutch one, as inalienable even after the economic rights are assigned or sold.',
    ],
    [
      'A Supplementary Protection Certificate (SPC) under EU law does what for a patented pharmaceutical or plant protection product?',
      [
        'Extends exclusivity beyond the twenty-year patent term, for up to five years, to compensate for time lost during regulatory marketing approval',
        'Grants an entirely new twenty-year patent term that begins running only once the original patent\'s own twenty-year term has fully expired',
        'Converts the patent into a trademark registration covering the same product for an indefinite period',
        'Automatically doubles the royalty rate a generic manufacturer must pay for the remainder of the patent term',
      ],
      0,
      'SPCs extend patent term by up to five years to compensate for time spent in regulatory testing before a drug can be marketed. EU Regulations 469/2009 (medicines) and 1610/96 (plant protection) calculate the extension from the gap between filing and first marketing authorisation.',
    ],
    [
      'Filing an application under the Patent Cooperation Treaty (PCT) achieves what, precisely?',
      [
        'Secures a single international filing that preserves the priority date and delays national or regional phase entry, without itself granting any patent',
        'Grants a single unified patent that is automatically enforceable in an identical way across every one of the PCT\'s contracting states',
        'Triggers automatic grant of a European patent without any examination by the EPO',
        'Produces a patent term extension identical in effect to a Supplementary Protection Certificate',
      ],
      0,
      'The PCT lets applicants file one international application, receive a search report, but each national office decides grant separately. Trademarks and designs use the Madrid Protocol and Hague System instead.',
    ],
    [
      'Under the EU Trade Secrets Directive (2016/943), information qualifies for protection as a trade secret only if it meets which combination of conditions?',
      [
        'Secrecy, commercial value derived from that secrecy, and reasonable steps by its holder to keep it secret',
        'It has been formally registered with a national or EU intellectual property office',
        'It has been disclosed only under a formally signed, notarised non-disclosure and confidentiality agreement negotiated specifically between the two contracting commercial parties involved',
        'It has existed in secret continuously for at least five full years before any claim is made',
      ],
      0,
      'Trade secret protection requires three conditions: the information is secret, derives commercial value from secrecy, and is subject to reasonable protective efforts.',
    ],
  ],
  phd: [
    [
      'The "likelihood of confusion" test in EU trademark law under the EUTMR weighs which factors together?',
      [
        'The similarity of the signs, the similarity of the goods/services, and the distinctiveness of the earlier mark, assessed globally',
        'Only whether the two marks are visually identical',
        'Only the reputation of the later-filed mark, regardless of any similarity between the goods or services offered under each sign or the earlier mark\'s own distinctiveness',
        'Only whether the goods are sold in the same physical shops',
      ],
      0,
      'The CJEU\'s "global assessment" doctrine, from cases like Sabel v Puma and Canon v MGM, treats these factors as interdependent - a highly distinctive earlier mark can create confusion even against a fairly dissimilar later sign, since distinctiveness and similarity trade off against each other.',
    ],
    [
      'Article 17 of the EU\'s 2019 Copyright Directive (formerly the contentious "Article 13") primarily addresses what?',
      [
        'The liability of online content-sharing platforms for copyright-infringing user uploads',
        'The harmonisation of copyright term across member states, a topic instead addressed by the separate Term Directive of 1993',
        'The right of academic authors to retain copyright in journal articles',
        'The scope of the private copying exception for physical media',
      ],
      0,
      'Article 17 makes platforms like YouTube directly liable for unauthorised uploads unless they obtain licences or make "best efforts" to prevent availability of notified works - a shift from the prior "safe harbour" hosting-liability model under the eCommerce Directive.',
    ],
    [
      'The Unified Patent Court (UPC), which began operating in 2023, has jurisdiction over what?',
      [
        'Infringement and validity of European patents and Unitary Patents across participating member states',
        'Only Unitary Patents, not classical European patents',
        'Only patent disputes involving pharmaceuticals',
        'Trademark disputes across the EU, a matter instead reserved exclusively to the EUIPO and national trademark courts',
      ],
      0,
      'The UPC gives a single court jurisdiction over Unitary Patents and classical European patents, eliminating the need to litigate separately in each country.',
    ],
    [
      'In Windsurfing Chiemsee v Huber (1999), the CJEU addressed whether a geographical name could function as a trademark, holding what?',
      [
        'A geographical name can be registered if it has acquired distinctiveness through use, even though purely descriptive geographical terms are ordinarily excluded',
        'Geographical names can never be registered as trademarks under any circumstances whatsoever',
        'Geographical names are automatically registrable whenever the goods in question are not actually produced in that place',
        'Geographical indications protected under separate EU agri-food quality schemes and ordinary trademarks are treated as fully identical legal concepts requiring the same registration route',
      ],
      0,
      'Descriptive geographical terms cannot be registered unless they have acquired secondary meaning through use—the public associates the name with a specific origin, not the place itself.',
    ],
    [
      'In Brüstle v Greenpeace (2011), the CJEU interpreted the Biotech Directive\'s exclusion of patents on uses of human embryos in what way?',
      [
        'The exclusion covers any human ovum from the moment of fertilisation capable of commencing human development, including use of stem cells derived by destroying an embryo',
        'The exclusion applies only to embryos older than fourteen days',
        'The exclusion covers only cloned embryos produced through somatic cell nuclear transfer, not naturally fertilised ones',
        'The Directive does not restrict biotech patents involving embryonic material in any way',
      ],
      0,
      'Inventions requiring human embryo destruction cannot be patented, even if the patented invention is the resulting cell line. Parthenotes fall outside the exclusion.',
    ],
    [
      'The "exhaustion of rights" doctrine in EU trademark and copyright law means what?',
      [
        'Once goods are first put on the market in the EEA with the rightsholder\'s consent, the rightsholder cannot block their further resale within the EEA',
        'A trademark right expires permanently after ten years',
        'Copyright cannot be exhausted, only trademarks can, since copyright is treated in most civil-law systems as a personal right attached permanently to its author regardless of any sale',
        'A rightsholder can block parallel imports from anywhere once goods leave the factory',
      ],
      0,
      'This is the legal basis for the EU\'s single market in genuine goods: cases like Silhouette v Hartlauer confirmed the EU applies regional (not international) exhaustion, so a rightsholder CAN still block parallel imports from outside the EEA even after EEA-consented first sale.',
    ],
    [
      'In Google France v Louis Vuitton (2010), the CJEU held that a search engine selling a competitor\'s trademark as a paid keyword does what?',
      [
        'Does not itself infringe the trademark, but the advertiser purchasing the keyword may infringe if the resulting ad harms the mark\'s origin or advertising function',
        'Always infringes the trademark regardless of how clearly the resulting sponsored advertisement distinguishes the advertiser\'s own goods from those of the trademark owner, and regardless of any actual confusion',
        'Never infringes under any circumstances, since keyword purchase is not \'use\' by anyone in the course of trade',
        'Infringes only if the search engine itself, rather than the advertiser, profits directly from that specific keyword sale',
      ],
      0,
      'Google\'s keyword sales are not trademark infringement, but an advertiser is liable if the ad is unclear and consumers can\'t tell whose goods are advertised.',
    ],
    [
      'TRIPS (the WTO\'s Agreement on Trade-Related Aspects of Intellectual Property Rights) was significant because it did what?',
      [
        'Bound WTO members to minimum IP standards enforceable through WTO dispute settlement',
        'Abolished patents on pharmaceuticals in developing countries',
        'Replaced the Berne and Paris Conventions entirely',
        'Created WIPO as a new international body, when in fact WIPO had already existed as a UN specialised agency two decades earlier',
      ],
      0,
      'TRIPS (1994) was the first IP agreement backed by a binding, cross-retaliation-capable enforcement mechanism - a WTO member found in breach can face trade sanctions in unrelated sectors, which is far stronger than anything WIPO treaties alone provided.',
    ],
    [
      'L\'Oréal v Bellure (2009) extended trademark protection for marks with a reputation to cover what, going beyond the traditional confusion-based test?',
      [
        'Taking unfair advantage of the mark\'s reputation through free-riding, even where there is no likelihood of confusion and no harm to the mark\'s distinctiveness',
        'Only cases where the copied product used packaging design identical, rather than merely similar, to the original',
        'Only counterfeit goods bearing a registered mark that is identical rather than merely similar',
        'Only situations where the defendant\'s total turnover in that specific product market, over the relevant infringement period, is shown to have exceeded the trademark owner\'s own comparable turnover',
      ],
      0,
      'A reputed mark\'s protection against "unfair advantage" doesn\'t require confusion—free-riding on the mark\'s image is enough.',
    ],
    [
      'The CJEU\'s ruling in Levola Hengelo v Smilde Foods (2018) addressed whether what could be protected by copyright?',
      [
        'The taste of a food product',
        'The recipe for a Dutch cheese spread as a literary work',
        'The trademark "Heks\'nkaas" itself',
        'The packaging design of a spreadable cheese',
      ],
      0,
      'The CJEU held that taste cannot be copyrighted because it cannot be identified with sufficient precision and objectivity to meet the "work" requirement under EU copyright law - a Dutch case (over the herb-cheese spread Heks\'nkaas) that settled a genuinely open doctrinal question.',
    ],
    [
      'The Madrid Protocol allows a trademark owner to do what?',
      [
        'File one international application designating multiple member countries through a single WIPO-administered procedure',
        'Obtain a single trademark automatically valid worldwide',
        'Skip national examination entirely in every designated country',
        'Register a mark that is generic in its country of origin, something no international or national trademark system permits regardless of filing route',
      ],
      0,
      'Madrid centralises filing and renewal administratively, but each designated country\'s office still examines the mark under its own substantive law and can refuse it - it is a filing convenience, not a single unitary right, which is a common point of confusion.',
    ],
    [
      'The doctrine of "first sale" in US copyright law and "exhaustion" in EU law both limit which right?',
      [
        'The distribution right, once a particular copy has been lawfully sold',
        'The reproduction right for digital copies',
        'The moral right of attribution, which in most jurisdictions cannot be exhausted by any sale of a physical or digital copy',
        'The right to perform the work publicly',
      ],
      0,
      'Both doctrines let owners of lawfully acquired copies resell or lend them without copyright holder permission, since the distribution right is exhausted by first sale.',
    ],
    [
      'In Stichting Brein v Ziggo and XS4ALL (2017), the CJEU held that operating an online indexing platform like The Pirate Bay constitutes what?',
      [
        'A \'communication to the public\' under the InfoSoc Directive, making the platform operators themselves liable, not merely the individual uploaders',
        'Mere passive hosting protected by the eCommerce Directive\'s safe harbour, carrying no liability at all',
        'Lawful conduct, because the indexing platform itself stores none of the actual copyrighted files, only hyperlinks, magnet links, and associated descriptive metadata',
        'A trademark infringement rather than a copyright matter, since indexing content is fundamentally a branding function',
      ],
      0,
      'Indexing torrent files with knowledge that most point to infringing content makes operators communicators to the public, well beyond neutral facilitation.',
    ],
    [
      'The 2019 EU \'SPC Manufacturing Waiver\' (Regulation 2019/933) permits what, as an exception to Supplementary Protection Certificate exclusivity?',
      [
        'EU-based generic and biosimilar manufacturers may produce the protected product during the SPC term solely for export to non-EU markets or for EU \'day-1\' stockpiling before expiry',
        'Any manufacturer worldwide may sell the SPC-protected product freely within the EU during the certificate\'s term',
        'SPC holders must license their product on FRAND-equivalent terms to at least one generic or biosimilar competitor immediately once the certificate itself is formally granted by the relevant national patent office',
        'The SPC term is shortened by two years for every waiver request an applicant successfully files',
      ],
      0,
      'The waiver lets EU-based generic manufacturers produce under the SPC term solely for non-EU export or EU stockpiling before expiry, addressing their disadvantage against non-EU competitors. Applies to SPCs filed on or after 1 July 2019.',
    ],
    [
      'Under EU design law, an unregistered Community design gives the holder protection against what, specifically?',
      [
        'Deliberate copying only, not independent creation of a similar design',
        'Any identical or similar design regardless of how it was created',
        'Nothing - unregistered designs receive no EU-level protection at all',
        'Only designs registered in the same member state as the holder, an approach the EU regime does not follow at all',
      ],
      0,
      'This is the key practical difference from a registered Community design, which is a true monopoly right effective even against independent creators: the unregistered right (lasting only three years) requires proving the alleged infringer actually copied the design.',
    ],
  ],
  professor: [
    [
      'In Sabam v Netlog (2012) and Scarlet Extended v SABAM (2011), the CJEU held that requiring an internet service provider to install a general content-filtering system to prevent copyright infringement would violate what?',
      [
        'The prohibition on imposing a general monitoring obligation under the eCommerce Directive, balanced against fundamental rights',
        'The Berne Convention\'s minimum term requirement',
        'The Paris Convention\'s national treatment principle',
        'The Rome Convention on performers\' rights, an instrument dealing with an entirely separate category of related rights unconnected to filtering obligations',
      ],
      0,
      'Filtering obligations breach Article 15 of the eCommerce Directive (no general monitoring duty) and burden freedom of business and user rights.',
    ],
    [
      'The Benelux Court of Justice, established in 1974, was historically significant as what?',
      [
        'One of the earliest international courts empowered to give preliminary rulings on shared Benelux legislation, including uniform trademark and design law',
        'The final court of appeal for all Dutch criminal cases, a function that in fact remains exclusively with the Hoge Raad der Nederlanden, as it always has been',
        'The first court to apply the CJEU\'s doctrine of direct effect',
        'The court that adjudicated the Dutch-Belgian border dispute over Baarle-Nassau',
      ],
      0,
      'It predates and partly modelled the preliminary-reference mechanism later scaled up hugely by the CJEU, and for decades was the authoritative interpreter of the Uniform Benelux Trademark and Designs Laws before EU-level unification largely displaced its IP docket.',
    ],
    [
      'Svensson v Retriever Sverige (2014) held that hyperlinking to a work already freely available online with the rightsholder\'s consent does what?',
      [
        'Does not require the rightsholder\'s separate authorisation, because it is not communicated to a \'new public\' beyond those the original posting already targeted',
        'Always infringes copyright regardless of the target content\'s availability or how the original rightsholder first published it',
        'Only infringes when the link uses framing techniques rather than an ordinary clickable hyperlink',
        'Requires separate authorisation only once the website doing the linking itself starts charging visitors a subscription fee to access its own pages',
      ],
      0,
      'Hyperlinking to freely accessible works reaches no "new public" beyond those already targeted in the original posting, so no fresh authorisation is needed.',
    ],
    [
      'In the CJEU\'s Football Dataco v Yahoo! (2012) ruling, the Court held that copyright protection for a database under the Database Directive requires what, specifically excluding what?',
      [
        'Original selection or arrangement reflecting the author\'s free creative choices, excluding significant labour and skill in collecting the data',
        'Only that significant financial investment went into compiling the data',
        'That the database be registered with a national IP office before litigation',
        'That the data itself be original, regardless of arrangement, a requirement the Database Directive does not in fact impose on copyright protection',
      ],
      0,
      'Copyright requires genuine creative selection or arrangement; "sweat of the brow" alone does not ground copyright protection.',
    ],
    [
      'The doctrine from IHT Internationale Heiztechnik v Ideal-Standard (1994) on trademark exhaustion within corporate group restructurings addressed what specific scenario?',
      [
        'Whether a trademark assigned to an unrelated entity in one member state could still be used to block imports of genuine goods bearing the same mark from another member state after the assignment severed economic links',
        'Whether a franchisee could use a trademark after the franchise agreement ended',
        'Whether a trademark could be registered simultaneously by two unrelated companies in different EU states',
        'Whether trademark rights survive the bankruptcy of the original owner, a distinct insolvency-law question governed by national bankruptcy statutes and the EU Insolvency Regulation rather than by the CJEU\'s trademark exhaustion case law at issue in this particular reference',
      ],
      0,
      'When trademark rights in different states are held by unrelated entities, the assignee can block imports of genuine goods—voluntary fragmentation breaks exhaustion.',
    ],
    [
      'GS Media v Sanoma (2016) extended the \'new public\' hyperlinking analysis to content posted without the rightsholder\'s consent, holding that liability turns chiefly on what?',
      [
        'Whether the linker knew or should have known the linked content was unlawfully posted, with knowledge presumed where the linking is done for financial gain',
        'Whether the linked content is hosted on a server physically located outside the European Union',
        'Whether the link uses a shortened URL rather than the original, unabbreviated web address',
        'Whether the original infringer who first posted the unlawful content has already been identified and successfully sued elsewhere',
      ],
      0,
      'Linking to unlawfully posted content can be communication to a "new public" when the linker knows of the unlawful posting. Knowledge is presumed where linking is for financial gain.',
    ],
    [
      'Article 6bis of the Berne Convention, on moral rights, was historically resisted by the United States chiefly because of tension with what feature of pre-1976 American copyright practice?',
      [
        'The "work made for hire" doctrine, under which the employer, not the individual creator, is deemed the author',
        'The absence of any copyright registration system',
        'The shorter US copyright term relative to Europe',
        'The US practice of granting copyright only to citizens, a restriction that in fact never existed under US copyright law at any point',
      ],
      0,
      'Work-for-hire assigns original authorship to the corporate employer, which conflicts with moral rights based on personal creator bonds.',
    ],
    [
      'The CJEU\'s "essential function" doctrine, developed from Hoffmann-La Roche v Centrafarm (1978) onward, defines a trademark\'s core legal purpose as what?',
      [
        'Guaranteeing the identity of origin of the marked goods or services to the consumer',
        'Maximising the economic return to the rightsholder',
        'Preventing any third party from ever using a similar sign',
        'Signalling the geographic origin of the goods, a function performed instead by geographical indications, not by ordinary trademark law',
      ],
      0,
      'A trademark\'s "origin function" is the doctrinal anchor for trademark protection—it extends only as far as needed to preserve the guarantee of origin.',
    ],
    [
      'Land Nordrhein-Westfalen v Renckhoff (2018) held that a student re-uploading a freely accessible photograph, previously posted with the author\'s consent, to a school website constitutes what?',
      [
        'A new act of communication to the public requiring fresh authorisation, because the photograph was placed on a different server independent of the original posting',
        'No new communication occurs at all, since the photograph had already been made freely and lawfully accessible to any internet user well before the student\'s re-upload',
        'Infringement only of moral rights, not of the economic reproduction or communication-to-the-public rights',
        'A use permitted under the EU quotation exception, because the re-upload served an educational purpose',
      ],
      0,
      'Re-uploading a file to an independent server is a new act of communication to the public requiring fresh authorisation, unlike hyperlinking which merely points to the original. If the original is removed, the re-uploaded copy persists independently, placing it outside rightsholder control.',
    ],
    [
      'In Dutch copyright doctrine, the "geschriftenbescherming" (protection of writings) was a sui generis regime that protected what, before its abolition in 2018?',
      [
        'Non-original written texts (like schedules or catalogues) lacking the "own, original character" needed for full copyright',
        'Oral folklore and unwritten traditions',
        'Computer source code specifically',
        'Photographs lacking artistic merit, a category that in fact was never covered by this specifically text-focused sui generis doctrine',
      ],
      0,
      'This Dutch doctrine protected factual texts lacking ordinary originality. It was abolished after CJEU cases made clear EU law required genuine originality.',
    ],
    [
      'In Huawei v ZTE (2015), the CJEU set out a negotiation framework determining when a standard-essential patent holder\'s request for an injunction does what?',
      [
        'Can constitute an abuse of a dominant position under Article 102 TFEU, unless the SEP holder first follows specified good-faith licensing steps before suing',
        'Is automatically an abuse of dominance in every single case, regardless of either party\'s prior conduct',
        'Can never amount to an abuse of dominance under Article 102 TFEU, because patent rights are treated as absolute and wholly immune from competition-law scrutiny under settled EU case law',
        'Depends solely on whether the implementer has already signed a non-disclosure agreement with the patent holder',
      ],
      0,
      'An injunction against a willing licensee may breach Article 102 unless the SEP holder alerts infringer, makes a FRAND offer, and implementer responds diligently.',
    ],
    [
      'The CJEU\'s ruling in Deckmyn v Vandersteen (2014) on the parody exception under the InfoSoc Directive held that a "parody" must satisfy which two conditions, without needing to satisfy others often assumed?',
      [
        'Evoking the original work while being noticeably different from it, and constituting an expression of humour or mockery, without needing originality of its own or explicit attribution of a comic intent',
        'Being registered as a parody with a national copyright authority and obtaining prior consent from the original author, formalities that no EU member state\'s copyright law in fact requires for the exception to apply',
        'Being non-commercial and used only for private, personal purposes',
        'Being shorter than the original work and using no more than ten percent of it',
      ],
      0,
      'A parody defence may fail if its message is discriminatory and harmful to the original author\'s reputation, even if it evokes the original work.',
    ],
    [
      'Sky plc v SkyKick UK Ltd (2020) addressed whether registering a trademark for an excessively broad specification, such as simply \'computer software,\' can amount to what?',
      [
        'Bad faith, at least in part, if there was no genuine intention to use the mark across the full breadth of goods or services claimed',
        'An automatic ground for revoking the entire registration regardless of any actual use shown for narrower goods within it',
        'A criminal offence under EU trademark law',
        'Grounds for the relevant national or EU trademark office to refuse registration outright before grant, a substantive review the CJEU held such offices are in fact required to conduct at the examination stage',
      ],
      0,
      'Bad faith can invalidate a registration in part for goods never genuinely intended for use, while surviving for goods actually used.',
    ],
    [
      'The "Slovak Telekom" and earlier "Bronner" lines of CJEU case law on refusal to license/supply as abuse of dominance under Article 102 TFEU are doctrinally significant to IP law because they define when what must yield to competition law?',
      [
        'An IP owner\'s right to refuse a licence, in narrow circumstances where refusal forecloses competition on a related market and the input is genuinely indispensable',
        'All patents automatically expire once the holder is found dominant in any market',
        'Trademark owners must license competitors on request in every EU member state',
        'Copyright cannot be enforced against a dominant firm under any circumstances, a blanket rule no EU competition or copyright authority has ever actually adopted in any reported decision',
      ],
      0,
      'Bronner (1998) set a demanding indispensability-plus-foreclosure test making compulsory licensing under competition law genuinely exceptional.',
    ],
    [
      'AMS Neve v Heritage Audio (2019) addressed which jurisdictional question under the EU Trade Mark Regulation?',
      [
        'Whether a court in the member state where consumers are targeted by online advertising and offers for sale has jurisdiction over an EU trademark infringement claim, even if the defendant is established elsewhere',
        'Whether an EU trademark can be enforced at all outside the single member state where it was originally registered',
        'Whether jurisdiction always lies exclusively with the courts of the country where the defendant is incorporated or otherwise formally established, regardless of where in the EU any resulting commercial harm to the trademark owner actually occurred',
        'Whether trademark disputes must be resolved through arbitration rather than litigation once an EU trademark has been granted',
      ],
      0,
      'Infringement jurisdiction includes states where consumers targeted by online content are located, not only where the defendant is established.',
    ],
  ],
};
